// extracted by mini-css-extract-plugin
module.exports = {"root":"PhoneBlock_root__ZbviO","interactive":"PhoneBlock_interactive__1rT5b","icon":"PhoneBlock_icon__2zFfG"};